import * as React from 'react'

const SvgTextZoomOutIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 16H13L7.75 4h-1.5L1 16h1.5l1.208-2.823h6.554L11.5 16zm-7.178-4.235l2.58-5.909h.196l2.557 5.909H4.323zM16.75 7H13v1.25h6.25V7h-2.5z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextZoomOutIcon
